module.exports = __webpack_public_path__ + "static/media/map_departure_station_icon_mini.ac42e066.svg";